import React from "react";
import {
    Box,
    Container,
    Grid,
    Typography,
    Stack,
    IconButton,
    Link,
} from "@mui/material";

import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";

import { Link as RouterLink } from "react-router-dom";

import IconUaiThai from "../assets/logouaithaiBranca.png";

export default function Footer() {

    return (
        <Box
            component="footer"
            sx={{
                background:
                    "linear-gradient(180deg, #071a3a 0%, #041226 100%)",
                color: "#fff",
                mt: 8,
            }}
        >
            {/* CONTEÚDO PRINCIPAL */}
            <Container sx={{ py: { xs: 6, md: 8 } }}>
                <Grid container spacing={{ xs: 4, md: 6 }} sx={{ display: "flex", justifyContent: "center" }}>
                    {/* BRAND */}
                    <Grid item xs={12} md={4}>
                        <Stack spacing={2} alignItems={{ xs: "center", md: "flex-start" }}>
                            <Box
                                component="img"
                                src={IconUaiThai}
                                alt="UaiThai Tiradentes"
                                sx={{
                                    width: 160,
                                    mb: 1,
                                }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "rgba(255,255,255,0.75)",
                                    textAlign: { xs: "center", md: "left" },
                                    maxWidth: 360,
                                    lineHeight: 1.7,
                                }}
                            >
                                A fusão perfeita entre a tradição tailandesa e a hospitalidade
                                mineira. Venha viver essa experiência gastronômica.
                            </Typography>
                        </Stack>
                    </Grid>

                    {/* NAVEGAÇÃO */}
                    <Grid item xs={12} sm={6} md={2}>
                        <Stack spacing={1.5} alignItems={{ xs: "start", md: "flex-start" }}>
                            <Typography variant="subtitle1" fontWeight={700}>
                                Navegação
                            </Typography>

                            {[
                              { title: "Início", path: "/" },
                              { title: "Nossa História", path: "/nossa-historia" },
                              { title: "Cardápio", path: "/pdf/cardapio.pdf", external: true },
                              { title: "Reservas", path: "/reservas" },
                            ].map((item) => (
                              <Link
                                key={item.title}
                                href={item.path}
                                target={item.external ? "_blank" : undefined}
                                rel={item.external ? "noopener noreferrer" : undefined}
                                underline="none"
                                sx={{
                                  color: "rgba(255,255,255,0.7)",
                                  fontSize: "0.9rem",
                                  "&:hover": { color: "#fff" },
                                }}
                              >
                                {item.title}
                              </Link>
                            ))}
                        </Stack>
                    </Grid>

                    {/* CONTATO */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Stack spacing={1.5} alignItems={{ xs: "start", md: "flex-start" }}>
                            <Typography variant="subtitle1" fontWeight={700}>
                                Contato
                            </Typography>

                            <Stack direction="row" spacing={1} alignItems="center">
                                <MdLocationOn />
                                <Typography variant="body2" color="rgba(255,255,255,0.75)" sx={{textAlign: "left"}}>
                                    R. Custódio Gomes, 150 - <br></br>Centro, Tiradentes - MG,<br></br>36325-000
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} alignItems="center">
                                <MdPhone />
                                <Typography variant="body2" color="rgba(255,255,255,0.75)">
                                    (32) 99172-0072
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} alignItems="center">
                                <MdEmail />
                                <Typography variant="body2" color="rgba(255,255,255,0.75)">
                                    contato@uaithai.com.br
                                </Typography>
                            </Stack>
                        </Stack>
                    </Grid>

                    {/* SOCIAL */}
                    <Grid item xs={12} md={3}>
                        <Stack spacing={2} alignItems={{ xs: "center", md: "flex-start" }}>
                            <Typography variant="subtitle1" fontWeight={700}>
                                Siga-nos
                            </Typography>

                            <Stack direction="row" spacing={1.5}>
                                <IconButton
                                    href="https://www.instagram.com/uaithaitiradentes/"
                                    target="_blank"
                                    sx={socialBtn}
                                >
                                    <FaInstagram />
                                </IconButton>
                                <IconButton
                                    href="https://www.facebook.com/uaithaitiradentes/"
                                    target="_blank"
                                    sx={socialBtn}
                                >
                                    <FaFacebookF />
                                </IconButton>
                                <IconButton
                                    href="https://whatsapp.com"
                                    target="_blank"
                                    sx={socialBtn}
                                >
                                    <FaWhatsapp />
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>

            {/* FOOTER BOTTOM */}
            <Box
                sx={{
                    borderTop: "1px solid rgba(255,255,255,0.08)",
                    py: 2,
                    textAlign: "center",
                }}
            >
                <Typography variant="caption" color="rgba(255,255,255,0.6)">
                    © {new Date().getFullYear()} UaiThai Tiradentes. Todos os direitos
                    reservados.
                </Typography>
            </Box>
        </Box>
    );
}

const socialBtn = {
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.2)",
    "&:hover": {
        backgroundColor: "rgba(255,255,255,0.12)",
    },
};